<template>
  <el-progress
    v-if="percentage"
    :percentage="percentage"
    :show-text="false"
    :size="size"
  />

  <el-tag
    v-else-if="application.state === 'creating'"
    type="primary"
    :size="size"
    effect="plain"
  >
    Creation in progress
  </el-tag>

  <el-tag
    v-else-if="application.state === 'restarting'"
    type="primary"
    :size="size"
    effect="plain"
  >
    Waiting for restart
  </el-tag>

  <el-tag
    v-else-if="application.state === 'destroying'"
    type="danger"
    :size="size"
    effect="plain"
  >
    Waiting for destroy
  </el-tag>

  <el-tag
    v-else-if="application.state === 'stopping'"
    type="danger"
    :size="size"
    effect="plain"
  >
    Waiting for shutdown
  </el-tag>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    application: Object,
    size: {
      type: String,
      default: 'mini'
    }
  },
  computed: {
    percentage () {
      return this.task && this.task.progress !== undefined ? parseInt(this.task.progress) : null
    },
    task () {
      return this.tasks.find((t) => t.applicationId === this.application.id &&
        t.image === 'ansible' && (t.running === '1'))
    },
    ...mapState(['tasks'])
  }
}
</script>
